import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {ProjectsService} from "@components/projects/projects.service";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-project-dialog',
    templateUrl: './project-dialog.component.html',
    styleUrls: ['./project-dialog.component.css']
})
export class ProjectDialogComponent implements OnInit {

    form: FormGroup;
    modalTitle = 'Unos novog projekta';

    constructor
    (
        public dialogRef: MatDialogRef<ProjectDialogComponent>,
        public taskService: TaskService,
        private projectService: ProjectsService,
        private toastr: ToastrService) {
    }

    ngOnInit(): void {

        this.form = new FormGroup({
            name: new FormControl('', Validators.required),
            type: new FormControl('kanban', Validators.required)
        })
    }


    closeModal(): void {
        this.dialogRef.close();
    }

    saveProject() {
        if (this.form.invalid) return;
        this.projectService.saveProject(this.form.get('name').value, this.form.get('type').value).subscribe((response: BackendResponse) => {
            if (response.type == 'success') {
                this.dialogRef.close();
            } else if (response.type == 'info') {
                this.toastr.info('Projekat već postoji u bazi.');
            }

        });
    }

}
